let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kxlgv")).then(() => parcelRequire('4OQXl'));